import { BaseContainerModel } from '../base-container.model';
import {bl_fi_generic_doc_custom_status_hdr_RowClass} from '../../dbschema';

export class GenericDocCustomStatusModel extends BaseContainerModel {
  bl_fi_generic_doc_custom_status_hdr: bl_fi_generic_doc_custom_status_hdr_RowClass = new bl_fi_generic_doc_custom_status_hdr_RowClass();
}
